// src/components/HeroCarousel.jsx
import { useEffect, useState } from "react";
import { Box, Container, Paper } from "@mui/material";

export default function HeroCarousel({
  images = [],
  interval = 2000,
  height = 380,
  maxWidth = 1200,
}) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!images.length) return;
    const id = setInterval(() => {
      setIdx((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(id);
  }, [images, interval]);

  return (
    <Container disableGutters maxWidth={false} sx={{ px: 0 }}>
      <Paper
        elevation={6}
        sx={{
          mx: "auto",
          width: "100%",
          maxWidth: maxWidth,
          height,
          borderRadius: 3,
          overflow: "hidden",
          position: "relative",
        }}
      >
        {images.map((src, i) => (
          <Box
            key={src + i}
            component="img"
            src={src}
            alt=""
            draggable={false}
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover", // גודל/חיתוך כמו בצילום המסך
              opacity: i === idx ? 1 : 0,
              transition: "opacity 600ms ease",
              display: "block",
            }}
          />
        ))}
      </Paper>
    </Container>
  );
}